module.exports = __webpack_public_path__ + "img/douyin-code.f8cf25d2.png";